// DISABLED: This component is temporarily disabled to prevent conflicts with fetchFullJob
// Re-enable after verifying the new data fetching flow works correctly

// Keeping imports commented for future re-enablement
// import { fetchJobDetails } from "../redux/slices/fetchJobDetailsSlice";
// import { selectApiUrls } from "../redux/slices/apiUrlSlice";
// import { selectJobDetails } from "../redux/slices/jobDetailsSlice";
// import { selectApiStatus } from "../redux/slices/apiStatusSlice";

const fetchMissingJobDetails = async (dispatch, getState, jobId) => {
  return; // Early return to disable functionality

  /* DISABLED CODE - DO NOT USE
  const state = getState();
  const jobDetails = selectJobDetails(state);
  const apiUrls = selectApiUrls(state);
  const apiStatus = selectApiStatus(state);

//   console.log("Job Details before fetching:", jobDetails); // Debugging log
//   console.log("API URLs:", apiUrls); // Debugging log
//   console.log("API Status:", apiStatus); // Debugging log

  // Iterate over jobDetails to find sections with empty arrays
  for (const [section, details] of Object.entries(jobDetails)) {
    // console.log(`Checking section: ${section}, details:`, details); // Debugging log

    const status = apiStatus[section];
    // console.log(`Status for section ${section}:`, status); // Debugging log
    const isPendingOrFailed = status === "pending" || status === "failed";


    if ((Array.isArray(details) && details.length === 0) || isPendingOrFailed) {
      const apiUrl = apiUrls[section];
      if (apiUrl) {
        // console.log(`Retrying fetchJobDetails for section: ${section}, API URL: ${apiUrl}`); // Debugging log
        await dispatch(fetchJobDetails({ jobId, apiUrls: { [section]: apiUrl } }));
      }
    }
  }
  */
};

export default fetchMissingJobDetails;
